import React from 'react';
import FetchService from '../FetchService';
import i18next from "i18next";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import Autocomplete from "@material-ui/lab/Autocomplete"
import { ListItemSecondaryAction, ListItemText, TextField, ListItem, List, IconButton, CircularProgress } from '@material-ui/core';

export default function CustomRelationsBox(props) {

    const [selectedToId, setSelectedToId] = React.useState({});

    const t = i18next.t.bind(i18next);

    function addRelation(relation) {
        if (!props.value.some(rel => rel[props.model.searchBarField] === relation[props.model.searchBarField])) {
            let aux = props.value;
            aux.push(relation);
            props.stateChangeHandler(props.name, aux);
        }
    }
    function removeRelation(relation) {
        props.stateChangeHandler(props.name, props.value.filter(rel => rel !== relation));
    }


    //searchbar statates
    const [text, setText] = React.useState('');
    const [selectedValue, setSelectedValue] = React.useState(null);
    const [open, setOpen] = React.useState(false);
    const [options, setOptions] = React.useState([]);
    const loading = open && options.length === 0;

    React.useEffect(() => {
        let active = true;
        if (!loading) {
            return undefined;
        }
        FetchService.simplePost(props.model.apiRoutes.LIST,
            {},
            (data) => {
                if (active) {
                    setOptions(data);
                }
            }
        )

        return () => { active = false };
    }, [loading]);

    React.useEffect(() => {
        if (!open) {
            setOptions([]);
        }
    }, [open]);

    // const containerStyle = {
    // borderStyle: 'solid',
    // borderRadius: '3px',
    // borderWidth: '1px',
    // color: 'lightgray',
    // padding: '10px',
    // margin: '16px'
    //}

    return (
        <div className={'form-group col-' + props.bootstrapColumSize}>
            <Row>
                <Col>
                    <label className='form-control-label' htmlFor={'input-edit-' + props.name}>
                        {t('addElements') + ' ' + t('model::fields::' + props.name)}
                    </label>
                </Col>

            </Row>
            <Row>
                <Col>
                    <Autocomplete
                        inputValue={text}
                        value={selectedValue}
                        onChange={(event, newValue) => {
                            setSelectedValue(newValue);
                        }}
                        open={open}
                        onOpen={() => {
                            setOpen(true);
                        }}
                        onClose={() => {
                            setOpen(false);
                        }}

                        options={options}
                        getOptionLabel={(option) => option[props.model.searchBarField]}
                        getOptionSelected={(option, value) => {
                            if (option[props.model.searchBarField] === value[props.model.searchBarField]) {
                                addRelation(value);
                                setOpen(false);
                                setText("");
                                setSelectedValue(null);
                            }
                        }}

                        loading={loading}
                        renderInput={(params) => (
                            <TextField {...params}
                                label={t('addElementsPlaceholder') }
                                onChange={(event) => {
                                    setText(event.target.value);
                                }}
                                variant="outlined"
                                InpuptProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                        <React.Fragment>
                                            {loading ? <CircularProgress color="black" size={20} /> : null}
                                            {params.InputProps.endAdornment}
                                        </React.Fragment>
                                    )
                                }}
                            />
                        )}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <List>
                        {props.value ? props.value.map((relation, index) => {
                            return (
                                <React.Fragment key={index}>
                                    <ListItem value={relation[props.model.searchBarField]}>
                                        <ListItemText primary={relation[props.model.searchBarField]} />
                                        <ListItemSecondaryAction>
                                            <IconButton edge={"end"} onClick={() => removeRelation(relation)}>
                                                <HighlightOffIcon />
                                            </IconButton>
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                </React.Fragment>
                            )
                        }) : ""}
                    </List>
                </Col>
            </Row>
        </div>
    )
}